import React, { useState } from "react";

import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";


function SupervisorVisits() {

  const [visits, setVisits] = useState([

    {
      id: 1,
      customer: "Ramesh Kumar",
      plot: "S253",
      datetime: "2 Jun, 2:00 PM",
      visitors: 2,
      ids: 2,
      status: "Confirmed",
      purpose: "Farm Visit",
      uploaded: [
        "Ramesh Kumar Aadhaar",
        "Lakshmi Aadhaar"
      ]
    },

    {
      id: 2,
      customer: "Priya Agarwal",
      plot: "F412",
      datetime: "3 Jun, 10:00 AM",
      visitors: 4,
      ids: 3,
      status: "Pending",
      purpose: "Farm Inspection",
      uploaded: [
        "Priya Agarwal Aadhaar",
        "Rajiv Agarwal Aadhaar"
      ]
    },

    {
      id: 3,
      customer: "Suresh Babu",
      plot: "Q330",
      datetime: "5 Jun, 11:30 AM",
      visitors: 1,
      ids: 0,
      status: "Pending",
      purpose: "Maintenance Check",
      uploaded: []
    }

  ]);

  const [selectedVisit, setSelectedVisit] = useState(visits[1]);

  const confirmVisit = (id) => {

    const updated = visits.map((v) =>
      v.id === id
        ? { ...v, status: "Confirmed" }
        : v
    );

    setVisits(updated);

  };

  const cancelVisit = (id) => {

    const updated = visits.filter(
      (v) => v.id !== id
    );

    setVisits(updated);

    setSelectedVisit(null);

  };

  return (

    <div>

      <Sidebar />

      <Navbar />


      <div className="supervisor-visits-container">

        <div
          style={{
            background: "white",
            minHeight: "100vh",
            width: "100%",
            color: "black",
            padding: "80px 0px 20px 40px",
            borderRadius: "20px",
            borderCollapse: "collapse",
            marginBottom: "30px",
            boxSizing: "border-box",            
          }}
        >

          <h1 style={{ marginTop: 0, marginBottom: 0 }}>
            Supervisor Visit Management
          </h1>

          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "20px",
              marginBottom: "20px"
            }}
          >

            <button>
              Upcoming
            </button>

            <button>
              Pending Approval (2)
            </button>

            <button>
              Past Visits
            </button>

          </div>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "30px"
            }}
          >

            <thead>

              <tr
                style={{
                  background: "#1f2937"
                }}
              >

                <th style={thStyle}>Customer</th>
                <th style={thStyle}>Plot</th>
                <th style={thStyle}>Date & Time</th>
                <th style={thStyle}>Visitors</th>
                <th style={thStyle}>IDs</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Action</th>

              </tr>

            </thead>

            <tbody>

              {visits.map((visit) => (

                <tr
                  key={visit.id}
                  style={{
                    borderBottom:
                      "1px solid #374151"
                  }}
                >

                  <td style={tdStyle}>
                    {visit.customer}
                  </td>

                  <td style={tdStyle}>
                    {visit.plot}
                  </td>

                  <td style={tdStyle}>
                    {visit.datetime}
                  </td>

                  <td style={tdStyle}>
                    {visit.visitors}
                  </td>

                  <td style={tdStyle}>
                    {visit.ids} uploaded
                  </td>

                  <td style={tdStyle}>

                    <span
                      style={{
                        background:
                          visit.status ===
                          "Confirmed"
                            ? "#dcfce7"
                            : "#fef3c7",

                        color:
                          visit.status ===
                          "Confirmed"
                            ? "#166534"
                            : "#92400e",

                        padding:
                          "5px 12px",

                        borderRadius:
                          "20px"
                      }}
                    >
                      {visit.status}
                    </span>

                  </td>

                  <td style={tdStyle}>

                    <button
                      onClick={() =>
                        setSelectedVisit(
                          visit
                        )
                      }
                    >
                      View
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

          {selectedVisit && (

            <div
              style={{
                border:
                  "1px solid #374151",
                borderRadius: "15px",
                padding: "20px"
              }}
            >

              <h3>
                Visit — {selectedVisit.customer} — {selectedVisit.plot}
              </h3>

              <p>
                {selectedVisit.datetime}
                {" • "}
                {selectedVisit.visitors}
                {" visitors • Purpose: "}
                {selectedVisit.purpose}
              </p>

              <h4>
                VISITOR IDS UPLOADED
              </h4>

              {selectedVisit.uploaded.map(
                (doc, index) => (

                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent:
                        "space-between",
                      marginBottom: "15px"
                    }}
                  >

                    <div>
                      📄 {doc}
                    </div>

                    <button>
                      View
                    </button>

                  </div>

                )
              )}

              <div
                style={{
                  marginTop: "25px",
                  display: "flex",
                  gap: "15px"
                }}
              >

                <button
                  style={{
                    background:
                      "#16a34a"
                  }}
                  onClick={() =>
                    confirmVisit(
                      selectedVisit.id
                    )
                  }
                >
                  Confirm Visit
                </button>

                <button
                  style={{
                    background:
                      "#dc2626"
                  }}
                  onClick={() =>
                    cancelVisit(
                      selectedVisit.id
                    )
                  }
                >
                  Cancel
                </button>

                <button>
                  Reschedule
                </button>

              </div>

            </div>

          )}

        </div>

      </div>

    </div>

  );

}

const thStyle = {
  padding: "15px",
  textAlign: "left",
  color: "#9ca3af"
};

const tdStyle = {
  padding: "18px 15px"
};

export default SupervisorVisits;